import React from "react";
import "./KomplettService.css";
import KomplettServiceimg from "../../assets/ttgimage5.jpg";

const KomplettService = () => {
  return (
    <div className="box-2-tak-till-golv-two-main-info">
      <div className="tak-till-golv-two-image-container-right-1-3-custom">
        <img src={KomplettServiceimg} alt="Square Image" />
      </div>
      <div className="tak-till-golv-two-text-container-3-custom">
        <div className="tak-till-golv-two-title-3-custom">
          Skräddarsydda Byggprojekt med Komplett Service
        </div>

        <div className="tak-till-golv-two-text-3-custom1">
          Vid Tak Till Golv erbjuder vi inte bara enkel byggtjänst, vi strävar
          efter att skapa skräddarsydda lösningar för varje kunds behov. Utöver
          våra omfattande bygg- och renoveringstjänster erbjuder vi också en
          komplett service för att underlätta för våra kunder genom hela
          processen.
          <br></br>
          <br></br>
          Vi förstår att varje projekt är unikt och kräver individuell
          uppmärksamhet och omsorg. Därför arbetar vi nära med varje kund för
          att förstå deras specifika behov och önskemål, och skapa en
          skräddarsydd plan som passar deras vision och budget.
          <br></br>
          <br></br>
          Vår kompletta service innefattar allt från planering och design till
          utförande och färdigställande. Vi tar hand om allt det administrativa
          arbetet, inklusive ansökningar om tillstånd och bygglov, så att våra
          kunder kan känna sig lugna och trygga genom hela processen. Med Tak
          Till Golv kan du vara säker på att ditt projekt kommer att utföras med
          precision och professionalism, från början till slut.
        </div>
      </div>
    </div>
  );
};

export default KomplettService;
